
define('template!webshopProductsDetailBodySiteAccessView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="header">\n    <div class="title">' +
((__t = ( _.i18n('webshop.products.siteAccess.title') )) == null ? '' : __t) +
'</div>\n    <div class="hint">' +
((__t = ( _.i18n('webshop.products.siteAccess.hint') )) == null ? '' : __t) +
'</div>\n</div>\n\n';
 if (hasSites) { ;
__p += '\n<table class="sites-table">\n    <thead>\n        <tr>\n            <th class="col-disabled">' +
((__t = ( _.i18n('webshop.siteAccess.disabled') )) == null ? '' : __t) +
'</th>\n            <th class="col-id">' +
((__t = ( _.i18n('webshop.siteAccess.siteId') )) == null ? '' : __t) +
'</th>\n            <th class="col-locale">' +
((__t = ( _.i18n('webshop.siteAccess.locale') )) == null ? '' : __t) +
'</th>\n            <th class="col-domain">' +
((__t = ( _.i18n('webshop.siteAccess.domain') )) == null ? '' : __t) +
'</th>\n        </tr>\n    </thead>\n    <tbody>\n        ';
 _.each(sites, function (site) { ;
__p += '\n        <tr>\n            <td class="col-disabled">\n                <input type="checkbox"\n                       class="site-disabled-toggle"\n                       value="' +
((__t = ( site.id )) == null ? '' : __t) +
'"\n                       ';
 if (site.disabled) { ;
__p += 'checked';
 } ;
__p += ' />\n            </td>\n            <td class="col-id"><code>' +
((__t = ( site.id )) == null ? '' : __t) +
'</code></td>\n            <td class="col-locale">' +
((__t = ( site.language )) == null ? '' : __t);
 if (site.region) { ;
__p += ' / ' +
((__t = ( site.region )) == null ? '' : __t);
 } ;
__p += '</td>\n            <td class="col-domain">' +
((__t = ( site.domain )) == null ? '' : __t) +
'</td>\n        </tr>\n        ';
 }); ;
__p += '\n    </tbody>\n</table>\n';
 } else { ;
__p += '\n<div class="empty">' +
((__t = ( _.i18n('webshop.siteAccess.noSites') )) == null ? '' : __t) +
'</div>\n';
 } ;
__p += '\n';

}
return __p
};});

